<div class="product-cart-container container-fluid py-4 px-2 px-md-4">
  <!-- Stepper / Breadcrumb -->
  <div class="row mb-4">
    <div class="col-12 d-flex justify-content-center">
      <div class="cart-stepper d-flex align-items-center">
        <!-- Step 1: Cart -->
        <div class="step active d-flex align-items-center">
          <div class="step-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
          </div>
          <span class="step-label">My Cart</span>
        </div>

        <div class="step-line"></div>

        <!-- Step 2: Delivery -->
        <div class="step d-flex align-items-center">
          <div class="step-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
          </div>
          <span class="step-label">Delivery</span>
        </div>

        <div class="step-line"></div>

        <!-- Step 3: Payment -->
        <div class="step d-flex align-items-center">
          <div class="step-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line></svg>
          </div>
          <span class="step-label">Payment</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row g-4">
    <!-- Cart Items Column -->
    <div class="col-lg-8">
      <div class="cart-header mb-3 d-flex justify-content-between align-items-center">
        <div>
          <h2 class="cart-main-title m-0">Shopping Cart</h2>
          <p class="text-muted small m-0 mt-1">Review your selected items</p>
        </div>
        <span class="badge-item-count" *ngIf="!isLoading">{{ totalItems }} Items</span>
        <span class="skeleton" *ngIf="isLoading" style="width: 70px; height: 26px; border-radius: 9999px;"></span>
      </div>

      <!-- Skeletons for Cart Items -->
      <ng-container *ngIf="isLoading">
        <div class="cart-item-card mb-3 skeleton-card" *ngFor="let item of [1, 2]">
          <div class="row align-items-center g-3 p-3 p-md-4">
            <div class="col-4 col-md-3">
              <div class="skeleton skeleton-img"></div>
            </div>
            <div class="col-8 col-md-5">
              <div class="skeleton skeleton-text mb-2" style="width: 35%; height: 12px;"></div>
              <div class="skeleton skeleton-text mb-3" style="width: 85%; height: 18px;"></div>
              <div class="skeleton skeleton-text" style="width: 45%; height: 16px;"></div>
            </div>
            <div class="col-12 col-md-4 d-flex flex-row flex-md-column justify-content-between align-items-center align-items-md-end h-100 border-top-mobile pt-3 pt-md-0">
              <div class="skeleton skeleton-text mb-0 mb-md-3" style="width: 80px; height: 22px;"></div>
              <div class="skeleton skeleton-pill" style="width: 110px; height: 36px; border-radius: 9999px;"></div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Loaded Cart Items -->
      <ng-container *ngIf="!isLoading">
        <ng-container *ngIf="carts.length > 0; else emptyCart">
          <div class="cart-item-card mb-3" *ngFor="let data of carts; let i = index">
            <div class="row align-items-center g-3 p-3 p-md-4">
              <!-- Product Thumbnail -->
              <div class="col-4 col-md-3">
                <div class="cart-img-wrap">
                  <img [src]="data?.url || 'assets/img/image_not_available.png'" [alt]="data?.productName" loading="lazy">
                </div>
              </div>

              <!-- Product Info -->
              <div class="col-8 col-md-5">
                <span class="brand-eyebrow" *ngIf="data?.productBrand || 'TreasureEVER'">{{ data?.productBrand || 'TreasureEVER' }}</span>
                <h4 class="cart-product-title mt-1 mb-2" [title]="data?.productName">{{ data?.productName }}</h4>
                
                <div class="cart-price-block d-flex align-items-baseline gap-2">
                  <span class="unit-price">₹{{ data?.productPrice }}</span>
                  <span class="unit-label text-muted small" *ngIf="data?.unit">/ {{ data.unit }}</span>
                </div>
              </div>

              <!-- Subtotal & Quantity Controls -->
              <div class="col-12 col-md-4 d-flex flex-row flex-md-column justify-content-between align-items-center align-items-md-end h-100 border-top-mobile pt-3 pt-md-0">
                <div class="item-subtotal-tag mb-0 mb-md-3">
                  <span class="subtotal-label d-none d-md-block text-muted small text-end">Subtotal:</span>
                  <span class="subtotal-val">₹{{ data?.amounts }}</span>
                </div>

                <!-- Quantity Pill Stepper -->
                <div class="cart-qty-stepper d-flex align-items-center">
                  <button type="button" class="btn-step" (click)="subtractQty(data, i)" title="Decrease quantity">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                  </button>
                  <span class="qty-num">{{ data?.quantity }}</span>
                  <button type="button" class="btn-step" (click)="addQty(data, i)" title="Increase quantity">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Empty Cart State -->
        <ng-template #emptyCart>
          <div class="empty-cart-card text-center p-5">
            <div class="empty-cart-icon-wrap mx-auto mb-3">
              <svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>
            </div>
            <h3 class="empty-title mb-2">Your cart is empty</h3>
            <p class="empty-desc text-muted mb-4">Explore our wide selection of wholesale products and add items to your cart.</p>
            <button type="button" class="btn-primary-action px-4 py-2" (click)="_location.back()">
              Explore Products
            </button>
          </div>
        </ng-template>
      </ng-container>
    </div>

    <!-- Order Summary Column -->
    <div class="col-lg-4">
      <!-- Skeleton Order Summary -->
      <div class="summary-card" *ngIf="isLoading">
        <div class="p-4">
          <div class="skeleton skeleton-text mb-4" style="width: 50%; height: 20px;"></div>
          <div class="d-flex justify-content-between mb-3" *ngFor="let line of [1, 2, 3, 4]">
            <div class="skeleton skeleton-text" style="width: 45%; height: 14px;"></div>
            <div class="skeleton skeleton-text" style="width: 25%; height: 14px;"></div>
          </div>
          <div class="border-top pt-3 mb-4 d-flex justify-content-between align-items-center">
            <div class="skeleton skeleton-text" style="width: 35%; height: 18px;"></div>
            <div class="skeleton skeleton-text" style="width: 30%; height: 24px;"></div>
          </div>
          <div class="skeleton skeleton-btn w-100" style="height: 48px; border-radius: 9999px;"></div>
        </div>
      </div>

      <!-- Loaded Order Summary -->
      <div class="summary-card sticky-top" *ngIf="!isLoading && carts.length > 0">
        <div class="p-4">
          <h3 class="summary-card-title mb-3 pb-2 border-bottom">Order Summary</h3>
          
          <div class="summary-line">
            <span class="summary-label">Subtotal ({{ totalItems }} items)</span>
            <span class="summary-value">₹{{ totalAmounts }}</span>
          </div>

          <div class="summary-line">
            <span class="summary-label">Discount</span>
            <span class="summary-value text-success">- ₹{{ discountAmounts }}</span>
          </div>

          <div class="summary-line">
            <span class="summary-label">Delivery</span>
            <span class="summary-value text-success">{{ deliverCharges === 0 ? 'FREE' : '₹' + deliverCharges }}</span>
          </div>

          <div class="summary-line border-bottom pb-3 mb-3">
            <span class="summary-label">Platform Fee</span>
            <span class="summary-value">₹{{ plateformFee }}</span>
          </div>
          
          <div class="summary-total-row mb-4">
            <span class="total-label">Grand Total</span>
            <span class="total-val">₹{{ grandTotal }}</span>
          </div>

          <button type="button" class="btn-primary-action w-100 py-3 mb-3 d-flex justify-content-center align-items-center gap-2" (click)="gotoCheckOut()">
            <span>Proceed to Checkout</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
          </button>

          <!-- Trust Badge -->
          <div class="trust-badge-wrap d-flex align-items-center gap-3 p-3">
            <div class="shield-icon flex-shrink-0">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><polyline points="9 12 11 14 15 10"></polyline></svg>
            </div>
            <p class="m-0 text-muted small lh-sm">
              <strong class="text-dark d-block">100% Secure Checkout</strong>
              Verified wholesale products & guaranteed authentic.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>